import { Organization } from "../../defines/organizations";
import { QueryData, ResponseData } from "../services/network/NetworkTypes";

export enum UserRole {
  Registrar = "registrar",
  Web = "web",
}
export enum Role {
  Admin = "admin",
  Business = "business",
}

export default class User {
  public orgLogo?: string;

  constructor(
    public id: number,
    public firstName: string,
    public lastName: string,
    public email: string,
    public roles: Array<UserRole>,
    public permissionRole: Role,
    public organization: Organization,
    public createdOn: Date,
    public integration_configurations: Array<string>
  ) {}

  static fromJSON(json: any): User {
    /*
          {
            "id": 2,
            "username": "rodriguesd@unicc.org",
            "first_name": "Diana",
            "last_name": "Rodrigues",
            "groups": [
                "admin"
            ]
          }
    */
    return new User(
      json.id,
      json.first_name,
      json.last_name,
      json.username,
      json.groups,
      json.role,
      window.ENV_ORG,
      json.date_joined,
      json.integration_configurations
    );
  }

  toJSON(): UserUpdateData {
    return {
      id: this.id,
      username: this.email,
    };
  }
}

export type UserCreateData = {
  username: string;
  first_name: string;
  last_name: string;
  groups: Array<UserRole>;
  role: Role;
  integration_configurations: Array<string>;
};

export type UserUpdateData = Partial<UserCreateData> & {
  id: number;
};

export type UserInvitationData = {
  email: string;
};

// This will be used to filter the data
export type UsersDataFilter = "search" | "group";
// Backend keys you can sort with
export type UserDataOrder =
  | "first_name"
  | "last_name"
  | "username"
  | "groups"
  | "date_joined"
  | "integration_configurations";

// This will help transform the sorting from local to backend keys.
export const userDataOrderTransform: Record<string, UserDataOrder> = {
  firstName: "first_name",
  lastName: "last_name",
  email: "username",
  role: "groups",
  dateJoined: "date_joined",
};

// These are the keys used for table listings
export type UserDataTableFields = keyof typeof userDataOrderTransform;

export type UsersQueryData = QueryData<UsersDataFilter, UserDataOrder>;
export type UsersResponseData = ResponseData<
  User,
  UsersDataFilter,
  UserDataOrder
>;

export type UserWithPublicKey = Required<User>;
